import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-stage-deep py-16 sm:py-20" aria-labelledby="results-title" data-id="element-148" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-149" data-mp="28ddkbhiv4puf">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-150" data-mp="2d6ztv0tqcdm0">
          What educators using this teacher ready say
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-151" data-mp="2m6cyng6wse0e">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-silverEdge bg-navy p-6 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-152" data-mp="2r70xup5ak15p" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-silver" aria-hidden="true" data-id="element-153" data-mp="3neqyr6oaedt8" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-silver" data-id="element-154" data-mp="3ilxuejwqd7ho">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-silverEdge pt-4" data-id="element-155" data-mp="3do60xlgftdbd">
                <span className="metal-surface flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-sm font-extrabold text-navyDeep" data-id="element-156" data-mp="38puvdmx6doyy">
                  {initials}
                </span>
                <span data-id="element-157" data-mp="58clzb1r89wf">
                  <b className="block text-sm text-silverBright" data-id="element-158" data-mp="55qch5vazkbk">{name}</b>
                  <small className="text-xs text-silverDark" data-id="element-159" data-mp="75cn7jyr2nn">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}